<template>
  <!-- Table Container Card -->
  <b-card
    no-body
  >
    <div class="ml-2 mr-2">
      <validation-observer ref="gatewayConfigRules">
        <b-form
          id="gateway-fee-configuration"
          @submit.prevent="handleSubmit"
        >
          <b-row>
            <b-col
              cols="12"
            >
              <h5 class="section-label mb-2 mt-2">
                {{ $t('Switch Transfer Gateway') }}
              </h5>
              <b-row class="match-height">
                <b-col
                  cols="12"
                >
                  <span
                    v-if="switchFormData.gateway"
                  >
                    {{ $t('Current Configured Intitution Gateway') }}
                  </span>
                  <b-form-radio-group
                    v-model="switchFormData.gateway"
                    :options="gatewayProviderOptions"
                    class="demo-inline-spacing"
                    name="radios-stacked1"
                    stacked
                    value-field="value"
                    text-field="text"
                  />
                </b-col>
              </b-row>

              <div class="mt-3">
                <Button
                  v-if="getUserPermission('SWITCH_TRANSFER_GATEWAY')"
                  :label="buttonLabel"
                  :loading="isLoading"
                  :disabled="isDisabled"
                  size="lg"
                  @click="handleSubmit"
                />
              </div>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </div>
    <FullScreenSpinner :show="showSpinner" />
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol,
  BForm, VBTooltip, BFormRadioGroup,
} from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import { modalMixins } from '@core/mixins/modal'
import { tableMixins } from '@core/mixins/table'
import { sweetAlert } from '@core/mixins/sweetAlert'
import {
  required, amount, positive,
} from '@validations'
import { permissionMixin } from '@core/mixins/permission'
import FullScreenSpinner from '@/views/components/spinner/FullScreenSpinner.vue'
import { toDateWithYear } from '../../../../../helpers/formatDate'
import Button from '../../../../components/button/Button.vue'
import { eChannelsPermission } from '../../../../../helpers/permissions'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BForm,
    ValidationObserver,
    FullScreenSpinner,
    Button,
    BFormRadioGroup,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  mixins: [modalMixins, tableMixins, sweetAlert, permissionMixin],
  data() {
    return {
      toDateWithYear,
      showSpinner: false,
      isDisabled: false,
      isLoading: false,
      required,
      amount,
      positive,
      buttonLabel: this.$t('Switch'),
      modalTitle: this.$t('Switch Transfer Gateway'),
      gatewayProviderOptions: [],
      switchFormData: {
        gateway: '',
      },
    }
  },
  mounted() {
    this.fetchCurrentIntitutionGateway()
    this.fetchGatewayProviders()
  },
  methods: {
    ...mapActions({
      getGatewayProviders: 'eChannels/getGatewayProviders',
      getCurrentIntitutionGateway: 'eChannels/getCurrentIntitutionGateway',
      updateIntitutionGateway: 'eChannels/updateIntitutionGateway',
    }),
    handleSubmit() {
      this.$refs.gatewayConfigRules.validate().then(async success => {
        if (success) {
          const text1 = this.$t('Are you sure you want to')
          const text2 = this.$t('this Intitution Transfer Gateway?')
          this.confirm(this.gatewayConfigAction, { text: `${text1} ${this.buttonLabel} ${text2}` })
        }
      })
    },
    async gatewayConfigAction() {
      try {
        this.isLoading = true
        this.isDisabled = true
        const formData = {
          gateway: this.switchFormData.gateway,
        }
        const response = await this.updateIntitutionGateway({ formData, permission: eChannelsPermission.SWITCH_TRANSFER_GATEWAY })

        const { status } = await response
        if (status === 200) {
          this.fetchGatewayProviders()
          const requestText = this.$t('Your request to')
          const successText = this.$t('Intitution Transfer Gateway was successful')
          this.alertSuccess({ text: `${requestText} ${this.buttonLabel} ${successText}` })
        }
      } catch (error) {
        error.response.data.errors.forEach(responseError => {
          const requestText = this.$t('Your request to')
          const reasonText = this.$t('Intitution Transfer Gateway failed. Reason')
          const errorMessage = `${requestText} ${this.buttonLabel} ${reasonText}: ${responseError.errorMessage}`
          this.alertError({ text: errorMessage })
        })
      } finally {
        this.isLoading = false
        this.isDisabled = false
      }
    },
    async fetchGatewayProviders() {
      try {
        this.showSpinner = true
        const response = await this.getGatewayProviders({ permission: eChannelsPermission.SWITCH_TRANSFER_GATEWAY })
        const { status, data } = await response
        if (status === 200 && data) {
          this.gatewayProviderOptions = data
        }
      } catch (error) {
        this.alertError({ text: error })
      } finally {
        this.showSpinner = false
      }
    },
    async fetchCurrentIntitutionGateway() {
      try {
        const response = await this.getCurrentIntitutionGateway()
        const { status, data } = await response
        if (status === 200 && data) {
          this.switchFormData.gateway = data
        }
      } catch (error) {
        this.alertError({ text: error })
      }
    },
  },
}
</script>
